import React, { useState } from 'react'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import useTraeDatos from '../hooks/useTraeDatos';
import { traeIdNombre, existeRegistro, recibeImagen, errores } from '../hooks/Funciones'
import fotoVacia from '../../paginas/img/fotoVacia.jpg'
import moment from 'moment'


const SubirEditCurso = ({ baseUrl, data, setData, setFuncion, registroSelect, TituloBtn, funcion }) => {

	const [registro, setRegistro] = useState(
		funcion === 'editar' ? registroSelect : 
		{ activo: true, imagePrev: fotoVacia, imageCertPrev: fotoVacia })
	const [error, setError] = useState({ activo: false })
	const [imagenOld, setImagenOld] = useState(registro.imagen)
	const [certOld, setICertOld] = useState(registro.imagencert)

	const creaFormData = (registro, METHOD, NombreIma, NombreCer) => {

			let {id, nombre, activo, imagen, imagenNueva, nombreImaNueva, descripcion, imagecert, imageCert, imagenNuevaCert, nombreImaNuevaCert } = registro
			//let {id, nombre, cedula, runt, telefono, ids_tipoingresos, imagen, imagenNueva, nombreImaNueva} = registro
			
			let f = new FormData()
			if (METHOD === 'PUT'){f.append('id', id)} 
			f.append('nombre', nombre)
			f.append('activo', activo)
			f.append('descripcion', descripcion === undefined ? '' : descripcion)
			f.append('METHOD', METHOD)

			if (METHOD === 'PUT'){
				f.append('imagen', imagenNueva !== undefined ? imagenNueva : imagen)
				f.append('nombre_imagen', nombreImaNueva)

				console.log('nombre_imagen',imagecert)
				console.log('imagencert',imagecert)

				f.append('imageCert', imagenNuevaCert !== undefined ? imagenNuevaCert : imagecert)
				f.append('nombre_cert', nombreImaNuevaCert)
				
				if (imagenNueva !== undefined){f.append('nombre_imagen_vieja', imagenOld)}
				if (imagenNuevaCert !== undefined){f.append('nombre_cert_vieja', certOld)}
			}else if (METHOD === 'POST'){
				// console.log('imageCert',imageCert)
				// console.log('nombre_cert',NombreCer)


				f.append('imagen', imagen)
				f.append('nombre_imagen', NombreIma)

				f.append('imageCert', imageCert)
				f.append('nombre_cert', NombreCer)


			} 
			return f
	}

	//Consulta para subir o crear los datos 
	const peticionPost = async () => {

		const fecha = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

		let { nombre, activo, imagen, descripcion, imageCert} = registro

		let formato = imagen.type.replace('image/', '.');
		let NombreImagen = imagen.name.replace(/[^A-Z0-9]+/ig, "_");
		let RutaServ = 'images/'
		console.log('nombreImagenFormat: ' + fecha + NombreImagen + formato)

		let RutaCert = 'plantillas/'
		let formatoCert = imageCert.type.replace('image/', '.');
		let NombreCert = imageCert.name.replace(/[^A-Z0-9]+/ig, "_");

		let formatosPermitidos = ['.png', '.jpeg', '.jpg']


		if (!existeRegistro(data, nombre)) {
			if (nombre !== undefined && imagen !== undefined) {
				if (imagen.size < 2000000 && formatosPermitidos.includes(formato) && imageCert.size < 2000000 && formatosPermitidos.includes(formatoCert)) {
					
					let NombreIma = RutaServ+fecha+NombreImagen+formato
					let NombreCer = RutaCert+fecha+NombreCert+formatoCert
					
					let f = creaFormData(registro, 'POST', NombreIma, NombreCer)

					await axios.post(baseUrl, f)

						.then(response => {
							console.log('result', response.data)
							let resultFormat = { 
								...response.data, 
								imagePrev: NombreIma, 
								imagen: NombreIma, 
								imageCertPrev: NombreCer,
								imageCert: NombreCer,
								imagencert: NombreCer
							}
							setData([resultFormat, ...data])
							setRegistro({ activo: false })
							errores('Limpio', setError)
							setFuncion('ver')

						}).catch(error => {
							console.log(error);
						})
				} else errores('Imagen', setError)
			} else errores('CampoVacio', setError)
		} else errores('Existe', setError)

	}

	const ProcedimientoPut = async () => {

		let {id, nombre, activo, imagen, descripcion, imagenNueva, nombreImaNueva, imagencert, imagenNuevaCert, nombreImaNuevaCert} = registro

		let f = creaFormData(registro, 'PUT')
		if (imagenNueva !== undefined) { f.append('nombre_imagen_vieja', imagenOld) }
		if (imagenNuevaCert !== undefined) { f.append('nombre_cert_vieja', certOld) }

		await axios.post(baseUrl, f)

			.then(response => {

				console.log('response',response.data)
				let dataNueva = data
				dataNueva.map(item => {
					if (item.id === id) {
						item.nombre = nombre
						item.activo = activo
						item.descripcion = descripcion
						item.imagePrev = imagen
						item.imagen = imagen

						item.imageCertPrev = imagencert
						item.imagencert = imagencert 
						//cuando hay una imagen nueva
						if (imagenNueva !== undefined) {
							item.imagePrev = nombreImaNueva === '' ? imagenNueva : nombreImaNueva
							item.imagen = nombreImaNueva === '' ? imagenNueva : nombreImaNueva
						}

						if (imagenNuevaCert !== undefined) {
							item.imageCertPrev = nombreImaNuevaCert === '' ? imagenNuevaCert : nombreImaNuevaCert
							item.imagencert = nombreImaNuevaCert === '' ? imagenNuevaCert : nombreImaNuevaCert
						}
					}
				})
				setData(dataNueva)
				console.log('enviado',dataNueva)
				errores('Limpio', setError)
			}).catch(error => {
				console.log('muestra erro: ' + error);
			})
		setFuncion('ver')
	}

	const peticionPut = () => {

		let { nombre, imagenNueva, imagenNuevaCert } = registro

		if (nombre !== '') {
			if (imagenNueva !== undefined) {
				//Cuando Hay una imagen nueva
				let formatosPermitidos = ['.png', '.jpeg', '.jpg', '.JPEG']
				let formato = typeof (imagenNueva) !== "string" ? imagenNueva.type.replace('image/', '.') : null;
				if (imagenNueva !== '' && imagenNueva.size < 2000000 && formatosPermitidos.includes(formato)) {
					ProcedimientoPut()
				} else { errores('ImagenIncorrecta', setError) }
			}if (imagenNuevaCert !== undefined) {
				//Cuando Hay una imagen nueva
				let formatosPermitidos = ['.png', '.jpeg', '.jpg', '.JPEG']
				let formato = typeof (imagenNuevaCert) !== "string" ? imagenNuevaCert.type.replace('image/', '.') : null;
				if (imagenNuevaCert !== '' && imagenNuevaCert.size < 2000000 && formatosPermitidos.includes(formato)) {
					ProcedimientoPut()
				} else { errores('ImagenIncorrecta', setError) }
			} else {
				ProcedimientoPut()
				console.log('texto')
			}

		} else errores('CampoVacio', setError)

	}

	const recibeImagenCert = (registro, setRegistro, funcion) => e => {
		if (funcion === 'editar'){
			let imagen = e.target.files[0]
			const fecha = moment(new Date()).format("YYYYMMDD-HHmmss");
			let formato = imagen.type.replace('image/','.');
			let NombreImagen = imagen.name.replace(/[^A-Z0-9]+/ig, "_");
			let RutaServ = 'plantillas/'
	
			setRegistro({
				...registro, 
				imageCertPrev: URL.createObjectURL(imagen),
				imagenNuevaCert: imagen,
				nombreImaNuevaCert: RutaServ+fecha+NombreImagen+formato
			})
		}else if (funcion === 'crear'){
			let picture = e.target.files[0]
			setRegistro({...registro, imageCertPrev: URL.createObjectURL(picture), imageCert: picture})
			console.log('Imagen: '+ picture)
		}
	}


	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					{error.activo ? <span className="error"> Error: {error.mensaje}</span> : null}
					<div><hr />

						<div className='row'>
							<div className='col-md-9'>
								<div className='custom-control custom-switch '>
									<input type='checkbox' name="activo" className='custom-control-input form-control-lg mb-4' id='customSwitches'
										checked={registro.activo}
										onChange={e => setRegistro({ ...registro, activo: !registro.activo })}
										readOnly
									/>
									<label className='custom-control-label' htmlFor='customSwitches'>Activar/Desactivar</label>
								</div>
								<MDBInput
									label="Nombre del Curso" name="nombre" required className={error.nombre ? "form-control is-invalid" : null} outline
									value={registro.nombre}
									onChange={e => setRegistro({ ...registro, nombre: e.target.value })}
								/>

								<div className="input-group">
									<div className="input-group-prepend">
									</div>
									<div className="custom-file">
										<input type="file" className="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
											name="imagen"
											onChange={recibeImagen(registro, setRegistro, funcion)}
										/>
										<label className="custom-file-label">
											Seleccionar Foto (400px x 400px)
										</label>
									</div>
								</div>

								<br></br>

								<div className="input-group">
									<div className="input-group-prepend">
									</div>
									<div className="custom-file">
										<input type="file" className="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
											name="certificado"
											onChange={recibeImagenCert(registro, setRegistro, funcion)}
										/>
										<label className="custom-file-label">
											Seleccionar Certificado (400px x 400px)
										</label>
									</div>
								</div>

								<div className="row">
									<div className='col-md-12'>
										<MDBInput label="Descripción" name="descripcion" required className={error.campoClave ? "form-control is-invalid" : null} outline
											value={registro.descripcion}
											onChange={e => setRegistro({ ...registro, descripcion: e.target.value })}
										/>
									</div>
								</div>

							</div>
							<div className="col-md-3">
								<div className="FotoPrev">
									{funcion === 'editar' ?
										<img alt="imagen" src={
											registro.imagePrev === registro.imagen ?
												baseUrl + "/" + registro.imagePrev
												: registro.imagePrev
										} />
										:
										<img src={registro.imagePrev} />
									}
								</div>

								<div className="FotoPrev">
									{funcion === 'editar' ?
										<img alt="imagen" src={
											registro.imageCertPrev === registro.imagencert ?
												baseUrl + "/" + registro.imageCertPrev
												: registro.imageCertPrev
										} />
										:
										<img src={registro.imageCertPrev} />
									}
								</div>

							</div>
						</div>

						<br />
						<div className="col text-center">
							<button onClick={funcion === 'editar' ? peticionPut : peticionPost} className="btn boton_estandar">{TituloBtn} </button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default SubirEditCurso